import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div style="text-align: justify;">
      <p class="mb-3">
        Ĉu vi povas nomi la trajton, komunan al absolute ĉiuj homoj sur la Tero?
      </p>
      
      <p class="mb-3">
        Nun oni insiste bombardas nin per asertoj, ke ĉiuj homoj estas samaj, identaj, ke inter ili ne ekzistas diferencoj, 
        ĉar ili estas nur HOMOJ. 
      </p>
      
      <p class="mb-3">
        Ĉu mi kredas tion? NE!
      </p>
      
      <p class="mb-3">
        HOMOJ ESTAS DIVERSAJ!
      </p>
      
      <p class="mb-3">
        Ili havas diversajn mensojn; kaj laŭ la hipotezo de Sapir-Whorf, la menso respeguliĝas en la lingvo, 
        kaj la lingvo respegulas la mondon en sia aparta aspekto. 
        Kurte dirite, ni vidas la mondon tra la krado de nia propra lingvo. 
        Sed la lingvoj estas tiel diversaj! 
        Mi memoras diskuton inter polo kaj hungaro pri la uzo de prepozicioj: en unu el la landoj oni diras “proksime al”, 
        sed en aliu – “proksime de”. 
        Do, unu lando estas pli “asidua”, ema alproksimiĝi al io, dum alia – pli “movema”, kiu ŝatas malproksimiĝi de lokoj. 
        Kaj kiel gravan rolon en tiu komparo ludas ĝuste Esperanto, INTERNACIA lingvo, 
        kiu ebligas priskribon de specialaĵoj de diversaj lingvoj sur unu platformo. 
        Jen estas la vera antaŭdestino de Esperanto: esti senpartia, neengaĝita peranto inter diversaj aferoj, 
        diversaj opinioj kaj viv-konceptoj. 
        Bedaŭrinde, ĝi eĉ ne provis agi tiamaniere kaj tiudirekte. 
        Male, ekde komenco Esperanta movado fariĝis kampo de bataloj kaj bataletoj de ĉiuj kontraŭ ĉiuj… 
        kaj tio daŭras ĝis nun&#128532;
      </p>
      
      <p class="mb-3">
        Sed tio estas nur flankeniro de la ĉefa temo: ĉu vere ĉiuj homoj estas samaj, nur ĉar ili estas homoj?
      </p>
      
      <p class="mb-3">
        Do, ni komparu, ekz., francon kaj maorion, kiuj vivas en absolute diversaj medioj: kio samas inter ili? 
        Klare, ke ili diversmaniere parolas, vidas kaj perceptas la vivon; sed ĉu ili faras same eĉ plej komunajn, 
        ŝajne, por la tuta homaro agojn? 
        Ĉu ili same manĝas? 
        Ne, franco manĝas ĉetable, per manĝilaro, kuiritajn aŭ almenaŭ preparitajn manĝaĵojn; 
        kaj maorio manĝas laŭvoje iun larvon, kun li ĵus elterigis. 
        Unu el ili ne povas manĝi tion, kion manĝas aliu: li ekmalsanos kaj mortos pro tio, kio estas manĝaĵo por aliu; 
        kio por unu estas vivsubteno, por aliu estas veneno. 
        Do, homoj eĉ ne manĝas same. 
      </p>
      
      <p class="mb-3">
        Ili eĉ ne parolas same, ĉar en kelkaj lingvoj de Sud-Afriko ekzistas la t.n. klakantaj sonoj, 
        prononcataj ne en elspiro, sed en enspiro. 
        Do, ankaŭ tio ne efikas por unuecigo.
      </p>
      
      <p class="mb-3">
        Ĉu la sola afero, kiun faras same ĈIUJ HOMOJ, estas spiri kaj … ekskrecii. 
        Verŝajne, pisas kaj fekas ĉiuj homoj same; do, gloru la simbolo de homa egaleco – HOMO EKSKRECIANTA! 
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Tio, kio nin unuecigas'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;